import React from 'react';
import { Check, ArrowUpRight } from 'lucide-react';
import { results } from '../data/mock';

const Results = () => {
  return (
    <section id="results" className="py-16 sm:py-24 bg-slate-950 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-emerald-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-cyan-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-emerald-400 text-sm font-semibold tracking-widest uppercase mb-4 block">
            The Outcomes
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
            What Organizations
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400">
              Gain
            </span>
          </h2>
          <p className="text-slate-400 text-base sm:text-lg max-w-3xl mx-auto">
            Real, practical outcomes that strengthen your people and your organization—
            results you can see in how teams communicate, lead, and perform.
          </p>
        </div>

        {/* Results Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {results.map((result, index) => (
            <div
              key={index}
              className="group p-5 sm:p-6 rounded-2xl bg-white/[0.02] border border-white/10 hover:border-emerald-500/30 hover:bg-white/[0.04] transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-10 h-10 rounded-xl bg-emerald-500/10 flex items-center justify-center mb-4 group-hover:bg-emerald-500/20 transition-colors">
                <Check className="h-5 w-5 text-emerald-400" />
              </div>

              {/* Label */}
              <h3 className="text-white font-bold text-base mb-2 group-hover:text-emerald-400 transition-colors">
                {result.label}
              </h3>

              {/* Description */}
              <p className="text-slate-400 text-sm leading-relaxed">
                {result.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="text-center mt-12 sm:mt-16">
          <p className="text-slate-500 text-sm max-w-2xl mx-auto">
            Outcomes vary by organization, program, and engagement level. These represent 
            common results experienced by organizations we partner with.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Results;
